import { render, staticRenderFns } from "./HebrewFooterComponent.vue?vue&type=template&id=b3569776"
import script from "./HebrewFooterComponent.vue?vue&type=script&lang=js"
export * from "./HebrewFooterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports